import * as moment from 'moment';
import t from 'utils/translations';

export const formatBusinessId = (id?: string): string => {
    if (!id) return '';
    else if (id.indexOf('-') >= 0) {
        return id;
    } else {
        return id.substring(0, 7).concat('-', id.substring(7, 8));
    }
};

export const formatDateWithTime = (date: number) =>
    moment(date).format('hh:mm, DD.MM.YYYY');

export const formatDate = (date?: number | string) => {
    if (!date) return '';
    try {
        return moment(date).format('DD.MM.YYYY');
    } catch (error) {
        console.log(
            error,
            'Tried to convert invalid date representation into date'
        );
        return '';
    }
};

export const formatMoney = (amount?: number): string => {
    if (amount === undefined) return '- €';

    return `${convertMoneyToStr(amount)} €`;
};

export const formatBigMoney = (amount?: number, kOrM?: string): string => {
    if (amount === undefined) return '- €';

    switch (kOrM) {
        case 'k':
            return `${convertMoneyToStr(amount / 1000)} k€`;
        case 'M':
            return `${convertMoneyToStr(amount / 1000000)} M€`;
        default:
            return `${convertMoneyToStr(amount)} €`;
    }
};

export const formatPercentage = (
    percentage?: number,
    digits?: number
): string => {
    if (!percentage) return '- %';
    return digits
        ? `${String(percentage.toFixed(digits)).replace('.', ',')} %`
        : `${String(percentage).replace('.', ',')} %`;
};

export const formatPersonnelCount = (count?: number): string => {
    if (!count) return '- henkilöä';

    return `${count} henkilöä`;
};

export const formatSource = (source?: string): string => {
    if (!source) return '';
    return `(${source})`;
};

export const formatStatementDate = (dateStr?: string): string => {
    if (!dateStr) return t('NOT_AVAILABLE');

    const year = dateStr.split('-')[0];
    const month = dateStr.split('-')[1];
    return `${month}/${year}`;
};

const convertMoneyToStr = (amount: number) => {
    const amountStr = String(amount);
    const [eurPart, centPart] = amountStr.split('.');
    let formattedEurPart = '';

    eurPart
        .split('')
        .reverse()
        .forEach((char, i) => {
            if (i % 3 === 0) formattedEurPart = ' ' + formattedEurPart;
            formattedEurPart = char + formattedEurPart;
        });

    return centPart ? `${formattedEurPart},${centPart}` : formattedEurPart;
};

export const formatThousandSpacing = (amount: number) => {
    const amountStr = String(amount);
    let formatted = '';

    amountStr
        .split('')
        .reverse()
        .forEach((char, i) => {
            if (i % 3 === 0) formatted = ' ' + formatted;
            formatted = char + formatted;
        });

    return formatted;
};
